// PrivateRoute.js
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/auth-context';
import { signOut } from 'firebase/auth';
import { auth } from '../utils/firebase';


const AdminRoute = () => {
    const { currentUser } = useAuth();

    const location = useLocation();

    const isAdmin = (currentUser !== null)
        && (currentUser.role?.toUpperCase() === "ADMIN");

    if (!isAdmin) {
        signOut(auth);
    }

    return isAdmin ? <Outlet /> : <Navigate to="/login" state={{ from: location }} />;
};

export default AdminRoute;